import { useMemo } from 'react';

import { SharesTitle, Interval } from 'types';

import { getOperationLabel } from 'utils/getOperationLabel';

import { getPartnersDataFromTitle } from '../utils/getPartnersDataFromTitle';
import sharesTitlesStatus from '../constants/sharesTitlesStatus';
import { PartnerRow } from '../types/PartnerRow';

type UseGetDataFromTitleProps = {
  title: SharesTitle;
};

export const useGetDataFromTitle = ({ title }: UseGetDataFromTitleProps) =>
  useMemo(() => {
    const defaultStatus = sharesTitlesStatus[0];

    const status =
      sharesTitlesStatus.find((s) => s.value === title?.status) ??
      defaultStatus;

    return {
      data: {
        operationId: title?.operation ?? '',
        operationTypeLabel: title?.operationType
          ? getOperationLabel(title.operationType)
          : '',

        intervals: title?.intervals ?? ([] as Interval[]),
        partners: title
          ? getPartnersDataFromTitle(title)
          : ([] as PartnerRow[]),

        statusLabel: status.label,
        statusBadge: status.badge,
      },
    };
  }, [title]);
